import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { Row, Col } from 'antd';
import API_URL from './../../constants/server';
import axios from 'axios';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router'
import Immutable from 'immutable';
import { Control, Form, actions } from 'react-redux-form/immutable';
import OrderSummaryWrapper  from './style';
import basicStyle from '../../config/basicStyle';
import { StripeProvider, Elements } from 'react-stripe-elements';
import SplitForm from './SplitForm';
import STRIPE_PUBLISHABLE from './../../constants/stripe';
import PAYMENT_SERVER_URL from './../../constants/server';
import ReactFlagsSelect from 'react-flags-select';
import 'react-flags-select/css/react-flags-select.css';
import { FLAG_LABELS } from '../../constants/country';
class OrderReview extends Component {

  constructor(props) {
    super(props)
    this.state = {
      stripe: null,
      campaign: null
    };

  }
  componentWillMount() {
    this.setState({ profile: {} });
    const { userProfile, getProfile } = this.props.auth;
    if (!userProfile) {
      getProfile((err, profile) => {
        this.setState({ profile });
      });
    } else {
      this.setState({ profile: userProfile });
    }
  }

  componentWillUpdate(){
    console.log( ' componentWillUpdate')
    //check difference
    
  }
  // componentDidReceiveProps(){
  //   console.log( ' componentWillReceiveProps')
    
  // }
  componentDidMount() {
    if (window.Stripe) {
      this.setState({stripe: window.Stripe(STRIPE_PUBLISHABLE)});
    } else {
      document.querySelector('#stripe-js').addEventListener('load', () => {
        // Create Stripe instance once Stripe.js loads
        this.setState({stripe: window.Stripe(STRIPE_PUBLISHABLE)});
      });
    }
    var recievedMessage = this.props.location.state.orderRequest;
    console.log(JSON.stringify(recievedMessage))

    
    this.setState({
      campaign: recievedMessage
    })
    console.log( recievedMessage)
    console.log ( STRIPE_PUBLISHABLE, ' ',  PAYMENT_SERVER_URL)
  }
  createCampaign(campaign){
    const adamId = this.props.match.params.appId;
    const { getAccessToken } = this.props.auth;
    const headers = { 'Authorization': `Bearer ${getAccessToken()}`}
    console.log(headers)
    const positiveKeywords = campaign.boostedKeywords;
    const negativeKeywords = campaign.negativeKeywords;

    const request = { ...campaign, adamId, positiveKeywords, negativeKeywords};
    console.log( 'campaign to be submitted : ' , request)
    this.setState( { request } );
    axios.post(`${API_URL}/searchads/campaigns/create/`, request, { headers } )
    .then(response => {
      this.setState({ message: 'asdfsdf', response: response.data})
      this.props.history.push(`/profile`) 
    })
    .catch(error => this.setState({ message: error.message }));
  }


  updateResult = ( success, text) => {
    if ( success){

    } else {

    }
  }

  updateError = ( err ) => {
    
  }

  render() {
    console.log( this.props)
    const { appDetail, campaign } = this.state;
    const { searchTerm, currentApp} = this.props;    
    const { rowStyle, colStyle } = basicStyle;

    if ( ! campaign){
      return (
        <div/>
      )
    }

    if (!currentApp){
      return <Redirect to="/"/>
    }

    return (
      <OrderSummaryWrapper>
        <div className="sub-header">订单摘要</div>

        <div className="main">
          <div className="info">
            <dl className="app-header">
              <dt>
                <img src={ currentApp.artworkUrl100} alt="screen"/>
              </dt>

              <dd>
                <span className="app-name">{ currentApp.trackCensoredName }</span>
                <span className="app-stores">
                  <span>苹果商店:</span>
                  { 
                      campaign && (this.state.campaign.budgetSplit.map((item, index) => {
                        const regionCode = item.key;
                
                        if (item.value > 0.0){
                          return (
                            <ReactFlagsSelect
                              key={regionCode}
                              className="regionInput"
                              defaultCountry={ regionCode } 
                              customLabels={ FLAG_LABELS } 
                              showSelectedLabel={ false } 
                              disabled={ true }/>
                          );
                        } else {
                          return null;
                        }
                       
                      }))
                  }
                </span>
              </dd>
            </dl>

            <h2>你的订单</h2>
            
            <div className="summary">
              <table>
                <tbody>
                  <tr>
                    <th>计划预算</th>
                    <td>
                      {/* {campaign.currency} */}
                      美金<span className="budget">${campaign.depositAmount}</span>
                    </td>
                  </tr>
                  {/* {
                    (+campaign.discount) == 0 ? <tr/> :
                      <tr>
                        <th>Discount</th>
                        <td>{campaign.currency}<span className="discount">${+campaign.discount}</span></td>
                      </tr>
                  } */}
                </tbody>
                <tfoot>
                  <tr>
                    <th>总付:</th>
                    <td>
                      {/* {campaign.currency} */}
                      美金<span className="total-amount">${campaign.depositAmount}</span>
                    </td>
                  </tr>
                </tfoot>
              </table>

              {/* <p>Vouched applied: GDC30%OFF</p> */}
            </div>

            <div className="promotion-code">
              <dl>
                <dt>使用优惠码</dt>
                <dd>
                  <div className="border-wrapper">
                    <input type="text" required/>
                    <span className="placeholder">
                    优惠码
                    </span>
                    <button>应用</button>
                  </div>
                </dd>
              </dl>
            </div>

            <h2>付款详情</h2>

            <div className="card-info">
              <StripeProvider  stripe={this.state.stripe}>

                <Elements>
                    <SplitForm 
                    fontSize={'18px'} 
                    updateResult= {this.updateResult.bind(this) }
                    updateError= {this.updateError.bind(this) }
                    campaign={ this.state.campaign }
                    auth={ this.props.auth }
                    profile= { this.state.profile }
                    currentApp= { currentApp }
                    history= { this.props.history }
                    />
                </Elements>
              </StripeProvider>
            </div>
          </div>
        </div>
      </OrderSummaryWrapper>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return { 

  }
}

function mapStateToProps(state) {
  return { 
    search: state.get('search'),
    currentApp: state.getIn( ['ItunesSearch', 'currentApp']),
    secondApp: state.getIn( ['ItunesSearch', 'secondApp']),
    searchTerm: state.getIn( ['ItunesSearch', 'searchTerm']),

  }
}



export default  (connect(
  mapStateToProps,
  mapDispatchToProps
)(  OrderReview) );



// WEBPACK FOOTER //
// ./src/containers/OrderReview/index.js